export default __webpack_public_path__ + "static/media/Leo.0f8e36d0.svg";